export const validation = {
  company_name: (value) => {
    if (!value || !value.trim()) {
      return "Company Name is required";
    }

    if (value.trim().length < 2) {
      return "Company Name must be at least 2 characters";
    }

    return "";
  },


  company_site_url: (value) => {
    if (!value) return "";

    try {
      const url = new URL(value);

      if (url.protocol !== "https:") {
        return "Only HTTPS URLs are allowed";
      }

      return "";
    } catch {
      return "Enter a valid Website URL";
    }
  },
  gst_number: (value) => {
    if (!value) return "";

    if (value.length < 5) {
      return "GST Number seems too short";
    }

    return "";
  },
};